/**
 * LandingFooter — extracted from LandingPage.jsx as the first slice of the
 * refactor. Pure presentational; relies only on the `t` (translations) prop.
 * No state, no effects. Safe to import/render anywhere.
 */
import React from 'react';

export default function LandingFooter({ t }) {
  return (
    <footer className="footer-vintage">
      <div className="footer-content">
        <div className="footer-brand footer-brand-seal">
          <img
            src="/seal/icraftz-wax-seal.png"
            alt="iCraftz"
            className="footer-seal-img"
          />
          <p className="footer-seal-tagline">Turn pages into practice.</p>
          <p className="footer-seal-tagline">Less noise, more thought.</p>
          <p className="footer-seal-tagline">Stop scrolling, start growing.</p>
        </div>

        <div className="footer-links">
          <h4>{t.footer.links.product || 'Product'}</h4>
          <a href="#library" className="footer-link">{t.footer.links.library || 'Book Library'}</a>
          <a href="#features" className="footer-link">{t.footer.links.features || 'Features'}</a>
          <a href="#how-it-works" className="footer-link">{t.footer.links.howItWorks || 'How it Works'}</a>
        </div>

        <div className="footer-links">
          <h4>Company</h4>
          <a href="/about" className="footer-link" data-testid="footer-about">About</a>
          <a href="/mission" className="footer-link" data-testid="footer-mission">Mission</a>
          <a href="/partner" className="footer-link" data-testid="footer-partner">Partner with Us</a>
          <a href="/for-authors" className="footer-link" data-testid="footer-for-authors">For Authors</a>
          <a href="/pricing" className="footer-link" data-testid="footer-pricing">Pricing</a>
        </div>

        <div className="footer-links">
          <h4>Resources</h4>
          <a href="/blogs" className="footer-link" data-testid="footer-blog">Blog</a>
          <a href="/contact" className="footer-link" data-testid="footer-contact">Contact</a>
          <a href="/privacy" className="footer-link" data-testid="footer-privacy">Privacy Policy</a>
          <a href="/terms" className="footer-link" data-testid="footer-terms">Terms of Use</a>
          <a href="mailto:hello@icraftz.com" className="footer-link">hello@icraftz.com</a>
        </div>
      </div>

      <div className="legal-disclaimer">
        <p>
          <strong>Disclaimer:</strong> iCraftz is a behavioural-change engine. Book summaries and insights shown here are original interpretations created for educational purposes only, not reproductions of copyrighted material. All book titles and author names are property of their respective owners. This platform is not affiliated with or endorsed by any publishers or authors. If you are a rights holder and have concerns, please contact us at <a href="mailto:hello@icraftz.com">hello@icraftz.com</a> and we will promptly address your request.
        </p>
      </div>

      <div className="footer-bottom">
        <p style={{ color: '#C9B18A', fontSize: '14px' }}>
          {t.footer.copyright}
        </p>
        <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
          <a href="/privacy" className="footer-link">Privacy Policy</a>
          <a href="/terms" className="footer-link">Terms of Use</a>
          <a
            href="/admin"
            className="footer-link footer-admin-link"
            data-testid="footer-admin-link"
            title="Admin only"
          >
            Admin
          </a>
        </div>
      </div>

      <div className="footer-copyright-2026" data-testid="footer-copyright-2026">
        © 2026 iCraftz. All rights reserved.
      </div>
    </footer>
  );
}
